define('personalization/listeners/pageview',['adlhelpers', 'personalization/personalization-wrapper', 'validatorhelpers'], function(ADL, personalization, validator) {
    'use strict';

    /*
     * COREUI-579
     *
     * EVENTS:
     *  pageview
     */


    /**
     * Handles checking the required ADL keys for a Search pageview
     *
     * @param {Object} [edap] - EDAP instance
     * @param {Object} [data] - ADL/Data object to use for the data
     */
    function handleSearch(edap, data) {
        var adl = new ADL(data),
            missingReqs = validator.checkRequiredProperties(adl, ['searchterm']);

        if (missingReqs.length > 0) {
            edap.error('Personalization search pageview missing required properties: ' + missingReqs.join(','), data);
        } else {
            personalization.setSearch(data);
        }
    }


    /**
     * Handles checking the required ADL keys for a PDP pageview
     *
     * @param {Object} [edap] - EDAP instance
     * @param {Object} [data] - ADL/Data object to use for the data
     */
    function handlePDP(edap, data) {
        var adl = new ADL(data),
            missingReqs = validator.checkRequiredProperties(adl, ['listingid']);

        if (missingReqs.length > 0) {
            edap.error('Personalization pdp pageview missing required properties: ' + missingReqs.join(','), data);
        } else {
            personalization.setPDP(data);
        }
    }


    function setupListeners(edap) {
        // NOTE: If this list of pagetypes continues to grow then it should be refactored into a lookup object: pagetype: function pointers
        edap.on('pageview', function(data) {
            switch (data.pagetype) {
                case 'search':
                    handleSearch(edap, data);
                    break;
                case 'property':
                    handlePDP(edap, data);
                    break;
                default:
                    // Do nothing since we don't handle anything other than specific events
            }
        });
    }

    return {
        setupListeners: setupListeners
    };
});

